export const logTypes = [
    'Personal Data',
    'Triage',
    'Labs',
    'EKG',
    'Preliminary Evaluation',
    'HPI',
    'Risk Factors',
    'Past Surgical History',
    'Medications',
    'ROS',
    'Physical Exam',
    'ADD-RS ',
    'Wells Score',
    'Working Diagnosis',
    'Imaging results'
];
//# sourceMappingURL=types.js.map